<template>
  <div>
    <v-btn
      v-for="(item, i) in items.slice(0, large ? items.length : 5)"
      :key="i"
      fab
      class="ma-2"
      color="info"
      :href="`${item.link}`"
      target="_blank"
      :small="!large"
    >
      <v-icon
        dark
        v-text="item.icon"
      />
    </v-btn>
  </div>
</template>

<script>
  export default {
    props: {
      large: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      items: [
        {
          name: 'Twitter',
          link: 'https://twitter.com/GiwanthaS',
          icon: 'mdi-twitter',
        },
        {
          name: 'Instagram',
          link: 'https://www.instagram.com/_g_i_w_i_',
          icon: 'mdi-instagram',
        },
        {
          name: 'Facebook',
          link: 'https://www.facebook.com/giwanthasandeepa.wijekoon/',
          icon: 'mdi-facebook',
        },
        {
          name: 'Github',
          link: 'https://github.com/giwi97',
          icon: 'mdi-github-circle',
        },
        {
          name: 'LinkedIn',
          link: 'https://www.linkedin.com/in/giwantha-sandeepa-wijekoon-3263a7185',
          icon: 'mdi-linkedin-box',
        },
        {
          name: 'Email',
          link: 'mailto: giwanthawijekoon@gmail.com',
          icon: 'mdi-email',
        },
        {
          name: 'Phone',
          link: 'tel: 766545982',
          icon: 'mdi-phone',
        },
      ],
    }),
  }
</script>
